module.exports = __webpack_public_path__ + "media/pro/apartment@3x-ea79b0f2.png";